import { render, staticRenderFns } from "./header-nav.vue?vue&type=template&id=226c75f0&scoped=true&"
import script from "./header-nav.vue?vue&type=script&lang=js&"
export * from "./header-nav.vue?vue&type=script&lang=js&"
import style0 from "./header-nav.vue?vue&type=style&index=0&id=226c75f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226c75f0",
  null
  
)

export default component.exports